import { RouteName } from '@mews-commander/enums';
import { useResolveRoute } from '@mews/routing';
import { Identifiable } from '@mews/std';
import CompanyName from './CompanyName';
import { ModalLink } from './Link';

export const CompanyLink = ({ id }: Identifiable) => {
    const resolveRoute = useResolveRoute();
    const url = resolveRoute(RouteName.CompanyDetail, { id });
    return (
        <ModalLink url={url} data-test-company-link={id}>
            <CompanyName id={id} />
        </ModalLink>
    );
};
